import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from 'src/app/_shared/components/footer/footer.component';
import { NavbarComponent } from 'src/app/_shared/components/navbar/navbar.component';

@Component({
  standalone: true,
  selector: 'neopos-public-layout',
  templateUrl: './public.layout.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, FooterComponent, NavbarComponent],
})
export class PublicLayoutComponent {}
